export default __webpack_public_path__ + "locales/fi/WebPlugins.json?hash=db5c0623796b59bb230ce813c882929b";